import React from 'react'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import './frequent.css'
const Frequentlyasked = () => {
  return (
    <div className='cont-qus '>
          <div className='freq'>
            <h1>Frequently asked Questions</h1>
          </div>
          <div className='qus'>
            <h6>Understand Channel Incentivisation</h6>
            <KeyboardDoubleArrowRightIcon />
          </div>
          <div className='qus'>
            <h6>Understand Channel Incentivisation</h6>
            <KeyboardDoubleArrowRightIcon />
          </div>
          <div className='qus'>
            <h6>Understand Channel Incentivisation</h6>
            <KeyboardDoubleArrowRightIcon />
          </div>
          <div className='qus'>
            <h6>Understand Channel Incentivisation</h6>
            <KeyboardDoubleArrowRightIcon />
          </div>
          <div className='qus'>
            <h6>Understand Channel Incentivisation</h6>
            <KeyboardDoubleArrowRightIcon />
          </div>
    </div>
  )
}

export default Frequentlyasked